<template>
  <div class="mt-2"><slot></slot></div>
</template>

<script setup lang="ts"></script>
